import React from 'react';
import PropTypes from 'prop-types';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

const Terms = ({ sectionOnly }) => {
  // All your sections as variables

  const section7 = (hideNumber = false) => (
  <section className="mb-8">
    <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">
      {hideNumber ? 'Limitation of Liability & Disclaimer of Warranties' : '7. Limitation of Liability & Disclaimer of Warranties'}
    </h2>
    <ul className="list-disc pl-6 space-y-2 text-gray-600">
      <li>
          The Service is provided strictly <strong>&quot;as is&quot; and &quot;as available&quot;</strong> without any warranties of any kind, express or implied. Paralegal (Pvt) Ltd makes no representations or guarantees about the accuracy, reliability, legality, or completeness of any translation.
        </li>
        <li>
          All translations are generated by artificial intelligence and may contain errors, omissions, or misinterpretations. You are solely responsible for reviewing, verifying, and validating any translated content before relying on it for legal, commercial, or official purposes.
        </li>
        <li>
          Paralegal (Pvt) Ltd, its directors, employees, and affiliates shall not be liable under any circumstance for any direct, indirect, incidental, consequential, or special damages resulting from the use of or inability to use the Service or any translation output.
        </li>
        <li>
          You agree not to hold Paralegal (Pvt) Ltd liable for any legal or financial consequences arising from the use of the translated content, and acknowledge that it is not a substitute for certified human translation or legal advice.
        </li>
        <li>
          To the fullest extent permitted by law, our total cumulative liability for any claim related to the Service shall not exceed the total amount paid by you for the specific document in question.
        </li>
    </ul>
  </section>
 );



  if (sectionOnly === 7) {
    return <div>{section7(true)}</div>; // hide the number in the
  }

  return (
    <div className="min-h-screen bg-[#fafafd] flex flex-col">
      <Header />
      <main className="flex-1 w-full mx-auto bg-[#fafafd] py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="bg-white p-8 rounded-2xl shadow-md border">
            <h1 className="text-4xl md:text-4xl font-bold text-gray-600 mb-6 text-center">
              Terms and Conditions
            </h1>
            <p className="text-lg text-gray-600 text-center mb-8">
              Effective Date: December 1, 2024
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">1. Introduction & Acceptance of Terms</h2>
              <p className="text-gray-600 mb-4">These Terms and Conditions (&quot;Terms&quot;) govern your use of the Paralegal.lk AI document translation service (the &quot;Service&quot;). By accessing or using our Service, you agree to comply with and be bound by these Terms. If you do not agree to these Terms, you may not use the Service.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">2. Description of Service</h2>
              <p className="text-gray-600 mb-4">The Service utilizes advanced artificial intelligence algorithms to translate legal documents on a pay-per-document basis. You acknowledge that as an AI-based service, translations may contain errors or inaccuracies.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">3. Use of the Service & User Responsibilities</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li><span className="font-semibold">Eligibility:</span> You must be at least 18 years old to use our Service.</li>
                <li><span className="font-semibold">Account Confidentiality:</span> You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account.</li>
                <li><span className="font-semibold">Accurate Information:</span> You agree to provide accurate, current, and complete information when using the Service.</li>
                <li><span className="font-semibold">Lawful Use:</span> You agree to use the Service only for lawful purposes and in accordance with all applicable Sri Lankan laws.</li>
                <li><span className="font-semibold">Responsibility for Review:</span> You are solely responsible for reviewing all translated documents for accuracy and completeness before use. The translations provided by the Service do not constitute legal advice.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">4. Prohibited Uses</h2>
              <p className="text-gray-600 mb-4">You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>Attempt to reverse-engineer, decompile, or otherwise disrupt the Service&apos;s functionality.</li>
                <li>Use any automated systems (e.g., bots, scrapers) to access the Service without our express written permission.</li>
                <li>Share your account credentials or knowingly allow multiple users to access a single account.</li>
                <li>Use the Service for any purpose that is illegal or infringes on the rights of a third party.</li>
              </ul>
              <p className="text-gray-600 mt-2">Violation of these terms may result in the immediate suspension or termination of your account and may be subject to legal action.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">5. Payments and Refunds</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li><span className="font-semibold">Fees:</span> The Service is provided on a pay-per-document basis. Fees are displayed at the time of purchase.</li>
                <li><span className="font-semibold">Payment:</span> You agree to provide valid and up-to-date payment information. We use a trusted third-party payment processor to handle transactions securely. We do not store your full payment card details.</li>
                <li><span className="font-semibold">Refunds:</span> Our <a href="/refund" className="text-pl_prim_color_1 underline">Refund Policy</a> is an integral part of these Terms. Please review it to understand the conditions under which a refund may be granted.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">6. Intellectual Property</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li><span className="font-semibold">Our IP:</span> All content and technology on our platform, including text, data, algorithms, logos, and graphics, are the exclusive property of Paralegal (Pvt) Ltd or its licensors and are protected by intellectual property laws. You may not copy, reproduce, or create derivative works from our content without prior written consent.</li>
                <li><span className="font-semibold">Your IP:</span> You retain all ownership rights to the documents you submit for translation. We do not claim any ownership of your source or translated documents.</li>
              </ul>
            </section>

            {/* Replace section 7 with {section7} */}
            {section7()}

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">8. Service Availability and Amendments</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>We strive to provide uninterrupted access but do not guarantee the Service will be available at all times.</li>
                <li>We reserve the right to modify, suspend, or discontinue the Service, or these Terms, at any time without prior notice. Continued use of the Service after changes are posted constitutes acceptance of the revised Terms.</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">9. Termination</h2>
              <p className="text-gray-600 mb-4">We may suspend or terminate your access to the Service at our sole discretion if you violate these Terms or for any other reason we deem necessary to protect our Service and users.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">10. Governing Law and Dispute Resolution</h2>
              <p className="text-gray-600 mb-4">These Terms are governed by the laws of Sri Lanka. Any disputes arising from the use of the Service shall be resolved through arbitration or a suitable legal proceeding in Sri Lanka.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-pl_prim_color_1 mb-4">11. Contact Information</h2>
              <p className="text-gray-600 mb-4">For any questions regarding these Terms, please contact us at <a href="mailto:admin@paralegal.lk" className="text-pl_prim_color_1 underline">admin@paralegal.lk</a>.</p>
              <p className="text-gray-600">
                Paralegal (Pvt) Ltd<br />
                95, Chemmani Road,<br />
                Nallur,<br />
                Jaffna 40000
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

Terms.propTypes = {
  sectionOnly: PropTypes.number,
};

export default Terms;